<template>
    <div class="cz2__modal-popup is-kiosk cz2__printing-progress">
        <focus-lock>
            <red-banner-button
                as="div"
            >
                {{ $t('PRINTING') }}
            </red-banner-button>
        </focus-lock>
    </div>
</template>

<style lang="scss">
    @import '../style/variables';

    #cz2.cz2 {
        .cz2__printing-progress {
            h1 {
                font-size: 81px;
            }
        }
    }
</style>

<script>
    import FocusLock from 'vue-focus-lock';

    import RedBannerButton from './RedBannerButton.vue';

    export default {
        components: {
            FocusLock,
            RedBannerButton,
        },
        methods: {
        },
    };
</script>
